import * as React from 'react';

import { Input, InputProps } from '@app/shared/ui/atoms/Common/Input';
import { cn } from '@app/shared/utils/common';

const NumberInput = React.forwardRef<HTMLInputElement, Omit<InputProps, 'type'>>(
  ({ className, ...props }, ref) => {
    return (
      <Input
        type="number"
        className={cn('no-number-input-spin-buttons text-secondary-foreground', className)}
        ref={ref}
        {...props}
      />
    );
  }
);
NumberInput.displayName = 'NumberInput';

export { NumberInput };
